@if (selectedCheck) {
<div class="admin-prompts-layout">
<div class="header-container">
    <div class="title-row">
        <!-- Published access level icon -->
        @if (selectedCheck?.published && selectedCheck?.access_level) {
        <mat-icon class="access-level-icon"
            [class.icon-subscription]="selectedCheck.access_level === 'subscription_level'"
            [class.icon-public]="selectedCheck.access_level === 'public'"
            [matTooltip]="selectedCheck.access_level === 'subscription_level' ? 'Published · Subscription only' : 'Published · Everyone'">
            {{ selectedCheck.access_level === 'subscription_level' ? 'lock' : 'public' }}
        </mat-icon>
        }
        <!-- Never published icon -->
        @if (!selectedCheck?.published && !selectedCheck?.published_at) {
        <mat-icon class="access-level-icon icon-unpublished"
            matTooltip="Not yet published">
            visibility_off
        </mat-icon>
        }
        <h3>{{selectedCheck?.name}}</h3>
    </div>
    <!-- Draft warning: published before but updated since last publish -->
    @if (selectedCheck?.status === 'draft' && selectedCheck?.published_at) {
    <div class="draft-warning-banner">
        <mat-icon class="draft-warning-icon">info</mat-icon>
        <span>This prompt set has been updated since it was last published. Republish to apply the latest changes.</span>
    </div>
    }
    <div class="actions-container">
        @if (selectedCheck?.published) {
        <!-- Published set: Show BOTH buttons -->
        <div class="publish-controls">
            <mat-form-field appearance="outline" class="access-level-select">
                <mat-label>Access Level</mat-label>
                <mat-select [(ngModel)]="selectedAccessLevel">
                    <mat-option [value]="PromptAccessLevel.SUBSCRIPTION_LEVEL">Subscription Only</mat-option>
                    <mat-option [value]="PromptAccessLevel.PUBLIC">Everyone</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="button-group">
                <button mat-button mat-flat-button color="primary" (click)="publishSet()">
                        <mat-icon>publish</mat-icon>
                        <span>{{'PublishSet' | translate}}</span>
                    </button>
                <button mat-button mat-flat-button color="warn" (click)="unpublishSet()">
                        <mat-icon>unpublished</mat-icon>
                        <span>{{'UnpublishSet' | translate}}</span>
                    </button>
            </div>
        </div>
        <small class="published-info">
                {{'LastPublished' | translate}} {{selectedCheck.published_at | date:'medium'}}
            </small> } @else {
        <!-- Unpublished set: Show only Publish button -->
        <div class="publish-controls">
            <mat-form-field appearance="outline" class="access-level-select">
                <mat-label>Access Level</mat-label>
                <mat-select [(ngModel)]="selectedAccessLevel">
                    <mat-option [value]="PromptAccessLevel.SUBSCRIPTION_LEVEL">Subscription Level</mat-option>
                    <mat-option [value]="PromptAccessLevel.PUBLIC">Everyone</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-button mat-flat-button color="primary" (click)="publishSet()">
                    <mat-icon>publish</mat-icon>
                    <span>{{'PublishSet' | translate}}</span>
                </button>
        </div>
        @if (selectedCheck?.published_at) {
        <small class="unpublished-info">
                    {{'PreviouslyPublished' | translate}} {{selectedCheck.published_at | date:'medium'}}
                </small> } }
    </div>
</div>

<!-- Output Schema Component -->
<app-output-schema class="output-schema-container"
    [promptSetId]="selectedCheck.prompt_set_id"
    [promptSetName]="selectedCheck.name"
    [currentOutputSchema]="selectedCheck.outputSchema"
    (schemaSaved)="onSchemaSaved($event)">
</app-output-schema>

<!-- Prompt List -->
<div class="prompt-list-container">
    <div class="prompts-header">
        <h5>{{'Prompts' | translate}}</h5>
        <div class="button-group">
            <button mat-button mat-flat-button color="accent" (click)="openSummaryPromptDialog()">
                <span>{{'ManageSummaryPrompt' | translate}}</span>
            </button>
            <button mat-button mat-flat-button color="primary" (click)="openPromptDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'NewPrompt' | translate}}</span>
            </button>
            <button mat-button mat-stroked-button color="warn" (click)="deleteAllPrompts()"
                [disabled]="!selectedCheck?.prompts?.length">
                <mat-icon>delete_sweep</mat-icon>
                <span>Delete All Prompts</span>
            </button>
        </div>
    </div>

    <!-- Display message when no prompts are available -->
    @if (selectedCheck?.prompts?.length === 0) {
    <div class="no-prompts-message">
        <p>{{'NoPromptsMessage' | translate}}</p>
    </div>
    } @else {
    <!-- Drag and drop container for prompts -->
    <div cdkDropList (cdkDropListDropped)="onPromptDrop($event)" class="prompts-drop-list">
        @for (prompt of selectedCheck?.prompts; track prompt.prompt_identifier) {
        <mat-expansion-panel cdkDrag (opened)="onPanelExpanded(prompt)" class="prompt-panel">
            <mat-expansion-panel-header>
                <mat-panel-title class="prompt-title">
                    <!-- Drag handle at the very beginning -->
                    <div cdkDragHandle class="drag-handle" [title]="'DragToReorder' | translate">
                        <mat-icon>drag_indicator</mat-icon>
                    </div>
                    <span class="rank-indicator">
                        @if (prompt.rank) {
                            {{prompt.rank}}
                        } @else {
                            {{'NotAvailable' | translate}}
                        }
                    </span> {{prompt.name || prompt.title}}
                </mat-panel-title>
                <mat-panel-description class="actions-container">
                    <div class="action-buttons">
                        <button mat-icon-button (click)="editPrompt(prompt); $event.stopPropagation()">
                                <mat-icon>edit</mat-icon>
                            </button>
                        <button mat-icon-button color="warn" (click)="deletePrompt(prompt); $event.stopPropagation()">
                                <mat-icon>delete</mat-icon>
                            </button>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="prompt-content">
                <div class="prompt-section">
                    <h4>{{'Context' | translate}}</h4>
                    <p>{{prompt.context}}</p>
                </div>
                <div class="prompt-section">
                    <h4>{{'Details' | translate}}</h4>
                    <p>{{prompt.details}}</p>
                </div>
            </div>
        </mat-expansion-panel>
        }
    </div>
    }
</div>
</div>
}